import { render, staticRenderFns } from "./messengerButton.vue?vue&type=template&id=dd25abe4&scoped=true"
import script from "./messengerButton.vue?vue&type=script&lang=js"
export * from "./messengerButton.vue?vue&type=script&lang=js"
import style0 from "./messengerButton.vue?vue&type=style&index=0&id=dd25abe4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../buybuttoncompact/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25abe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd25abe4')) {
      api.createRecord('dd25abe4', component.options)
    } else {
      api.reload('dd25abe4', component.options)
    }
    module.hot.accept("./messengerButton.vue?vue&type=template&id=dd25abe4&scoped=true", function () {
      api.rerender('dd25abe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "integrationtest/src/components/messengerButton.vue"
export default component.exports